// NotFound.jsx
import React from "react";
import { Link } from "react-router-dom";
import "../../assets/Style.css";
export default function NotFound() {
    return (
        <div style={styles.container}>
            <h1 style={styles.code}>404</h1>
            <h2 style={styles.title}>Page Not Found</h2>
            <p style={styles.desc}>
                Oops! The page you are looking for doesn't exist.
            </p>

            <Link to="/" style={styles.btn} className="banner-btn-1">
                Go Back Home
            </Link>
        </div>
    );
}

const styles = {
    container: {
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",

        color: "#fff",
        textAlign: "center",
    },
    code: {
        fontSize: "120px",
        fontWeight: "bold",
        margin: 0,
 
    },
    title: {
        fontSize: "32px",
        margin: "10px 0",
    },
    desc: {
        fontSize: "18px",
        opacity: 0.8,
        marginBottom: "20px",
    },

};